// MR-L4 — **THE PAINTED CAULDRON'S PLACE IN THE ART, AS DATA.**
//
// The Magic Room's background is full-bleed and the cauldron a member taps is a HOTSPOT anchored to
// the painting rather than to the page: these four fractions and the art's own pixel size are what
// turn a cover-cropped background into a rectangle at every viewport. They were measured off the
// picture, they are numbers, and they lived in `src/App.tsx` — where **nothing could reach them**,
// which is `scripts/r8-leaves.mjs`'s own currency (*the thing that had to move is the thing nothing
// could reach*) and the same move P2-7 already made for the shelf beside it.
//
// It imports NOTHING, so a `.mjs` gate loads and RUNS it.

/** The background art's own pixel size. Every fraction below is read against this. */
export const MR_IMG_W = 1672;
export const MR_IMG_H = 941;

/**
 * The painted cauldron's bounding box, as fractions of the art. **Fractions and not pixels**, which
 * is the whole reason the hotspot tracks the room: the background is cover-cropped, so the only
 * thing that survives a resize is a proportion of the picture.
 */
export const MR_CAULDRON = { x0: 0.605, y0: 0.485, x1: 0.975, y1: 0.925 };
